import { render } from "./BandMember.vue?vue&type=template&id=1a9d038e&scoped=true"
import script from "./BandMember.vue?vue&type=script&lang=js"
export * from "./BandMember.vue?vue&type=script&lang=js"

import "./BandMember.vue?vue&type=style&index=0&id=1a9d038e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a9d038e"]])

export default __exports__